export const cleanDiseaseName = (name: string) => (name || '').replace(/[^A-Za-z0-9 -]/g, '');
